var _path, _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan10, _tspan11, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRiskLevelThermometer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 681,
    height: 94,
    viewBox: "0 0 681 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.566 52.3546C176.186 51.089 176.186 48.913 177.566 47.6472L182.575 43.0523C183.313 42.3755 184.278 42 185.279 42H194H195.803H659.598H661H670.123C671.124 42 672.088 42.3753 672.826 43.0519L677.835 47.6454C679.215 48.911 679.216 51.087 677.836 52.3528L672.826 56.9477C672.089 57.6245 671.124 58 670.122 58H661H659.598H195.803H194H185.279C184.278 58 183.313 57.6247 182.576 56.9481L177.566 52.3546Z",
    fill: "url(#paint0_linear)"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#213D58",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Nunito Sans",
    fontSize: 24,
    letterSpacing: "0px"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 201.305,
    y: 24.396
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fill: "#213D58",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Nunito Sans",
    fontSize: 24,
    letterSpacing: "0px"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 311.305,
    y: 24.396
  }, "2"))), /*#__PURE__*/React.createElement("text", {
    fill: "#213D58",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Nunito Sans",
    fontSize: 24,
    letterSpacing: "0px"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 421.305,
    y: 24.396
  }, "3"))), /*#__PURE__*/React.createElement("text", {
    fill: "#213D58",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Nunito Sans",
    fontSize: 24,
    letterSpacing: "0px"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 531.305,
    y: 24.396
  }, "4"))), /*#__PURE__*/React.createElement("text", {
    fill: "#213D58",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Nunito Sans",
    fontSize: 24,
    letterSpacing: "0px"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 641.305,
    y: 24.396
  }, "5"))), /*#__PURE__*/React.createElement("text", {
    fill: "#0A0D0D",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Nunito Sans",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 180.467,
    y: 88.106
  }, "Very low"))), /*#__PURE__*/React.createElement("text", {
    fill: "#0A0D0D",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Nunito Sans",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 305.171,
    y: 88.106
  }, "Low"))), /*#__PURE__*/React.createElement("text", {
    fill: "#0A0D0D",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Nunito Sans",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 400.249,
    y: 88.106
  }, "Medium"))), /*#__PURE__*/React.createElement("text", {
    fill: "#0A0D0D",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Nunito Sans",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 519.03,
    y: 88.106
  }, "High"))), /*#__PURE__*/React.createElement("text", {
    fill: "#0A0D0D",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Nunito Sans",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 617.006,
    y: 88.106
  }, "Very high"))), /*#__PURE__*/React.createElement("text", {
    fill: "#213D58",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Nunito Sans",
    fontSize: 16,
    fontWeight: "bold",
    letterSpacing: "0.5px"
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 1,
    y: 55.264
  }, "RISK LEVEL"))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 208.829,
    y1: 57.008,
    x2: 648.88,
    y2: 57.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFCE82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285077,
    stopColor: "#F9C83A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501135,
    stopColor: "#F37021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.750343,
    stopColor: "#AD3769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4432F"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskLevelThermometer);
export default __webpack_public_path__ + "static/media/risk-level-thermometer.d9bbee60.svg";
export { ForwardRef as ReactComponent };